module.exports = __webpack_public_path__ + "static/media/ordi004.78ffcc60.jpg";